/* eslint-disable @typescript-eslint/no-magic-numbers */
import { BasketErrorModel, DEFAULT_ERROR_TEXT } from 'models/Errors';
import { logsHelper } from 'helpers';
import { errorToBasketErrorModel } from './errorToBasketErrorModel';

const GET_GLOBAL_OBJECT_INTERVAL = 200;

export class ExternalScriptHelper {

    public getExternalScript<T>(name: string): T | null {
        const script = (window as any)[name];

        return (script as T) ?? null;
    }

    public async getExternalScriptWithTimeout<T>(name: string, maxAttempts: number = 20): Promise<T | null> {
        let script: T | null = null;

        try {
            script = await this.waitForExternalScript(name, maxAttempts);
        } catch (error) {
            logsHelper.error(errorToBasketErrorModel(error, 'getExternalScriptWithTimeout'));
        }

        return (script as T) ?? null;
    }

    private async waitForExternalScript(name: string, maxAttempts: number): Promise<any> {
        return new Promise((resolve, reject) => {
            let script = null;
            let attempt = 0;

            const interval = setInterval(() => {
                attempt++;
                if (attempt > maxAttempts) {
                    clearInterval(interval);

                    return reject(new BasketErrorModel(DEFAULT_ERROR_TEXT, `Attempts to find the script ${name} have been exhausted`, 'externalScriptHelper:waitForExternalScript'));
                }

                script = (window as any)[name];
                if (script) {
                    clearInterval(interval);

                    return resolve(script);
                }
            }, GET_GLOBAL_OBJECT_INTERVAL);
        });
    }
}

export const externalScriptHelper = new ExternalScriptHelper();